<form [formGroup]="form">
  <base-form-header [mode]="null" createLabel="Archivage du contrat"></base-form-header>
  <mat-dialog-content fxLayout="column">
    <p>
      Le contrat est actif du {{ contract.startValidityDate | date: 'dd/MM/yyyy' }} au
      {{ contract.endValidityDate | date: 'dd/MM/yyyy' }}.
    </p>
    <p>Pour l'archiver, veuillez saisir une date de fin antérieure à aujourd'hui.</p>
    <mat-form-field appearance="fill">
      <mat-label>Nouvelle date de fin</mat-label>
      <input matInput [matDatepicker]="picker" formControlName="endValidityDate" [max]="maxDate" />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button color="primary" [loading]="loading" (click)="archive()">VALIDER</button>
  </mat-dialog-actions>
</form>
